import {useLayoutEffect, useEffect, useState} from 'react';

// «Быстрый набор» (панель типовых чекаут-сумм + кнопка LEG «дописать остаток до
// финиша») — фича только для x01 (501/301/601/1001). Способность определяем по методу
// calculateRemainder: он есть лишь у x01-моделей. В countup/cricket/sector/big_round
// его нет — панель прячем, иначе клик по LEG падает (Sentry FRONTEND-CA).
export function supportsFastInput(Game) {
  return typeof Game?.calculateRemainder === 'function'
}

export function winner_score(score_1, score_2) {
  if (score_1 > score_2) {
    return 1
  }
  if (score_1 < score_2) {
    return 2
  }
  return 0
}

export const debounce = (func, delay) => {
  let debounceHandler;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceHandler);
    debounceHandler = setTimeout(() => func.apply(context, args), delay);
  };
};

export function round(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    window.addEventListener('orientationchange', updateSize);
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
      window.removeEventListener('orientationchange', updateSize);
    }
  }, []);
  return size;
}

export function useDebouncedEffect(effect, deps, delay) {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, {[key]: {}});
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, {[key]: source[key]});
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function Resize({onResize, delay = 0}) {
  const [windowWidth, windowHeight] = useWindowSize()
  useDebouncedEffect(() => {
    onResize([windowWidth, windowHeight])
  }, [onResize, windowWidth, windowHeight], delay)
  return null
}

export function lazyRetry(componentImport, name) {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem(`retry-${name}-refreshed`) || 'false'
    );
    componentImport().then((component) => {
      window.sessionStorage.setItem(`retry-${name}-refreshed`, 'false');
      resolve(component);
    }).catch((error) => {
      if (!hasRefreshed) { // not been refreshed yet
        window.sessionStorage.setItem(`retry-${name}-refreshed`, 'true');
        return window.location.reload();
      }
      reject(error);
    });
  });
}

export function wait(delay) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function randomFloor(min, max, precision = 2) {
  const factor = Math.pow(10, precision);
  const random = Math.random() * (max - min) + min;
  return Math.floor(random * factor) / factor;
}

export function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex > 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

export function range(start, end) {
  const step = start < end ? 1 : -1;
  const length = Math.abs(end - start) + 1;

  return Array.from({length}, (_, i) => start + i * step);
}

export function deferred(name = 'non-name', silent = false) {
  let resolve, reject, state = 'pending'

  let promise = new Promise((res, rej) => {
    resolve = res
    reject = rej
  })
  if (silent) {
    promise = promise.catch(error => {
      if (error) {
        throw error
      }
      return undefined
    })
  }

  return {
    name: () => name,
    state: () => state,
    promise: () => promise,
    resolve: (...args) => {
      if (state === 'pending') {
        state = 'resolved'
        resolve(...args)
      }
    },
    reject: (...args) => {
      if (state === 'pending') {
        state = 'rejected'
        reject(...args)
      }
    },
  }
}

export function getCookie(name) {
  let cookieValue = null;

  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }

  return cookieValue;
}